import React from 'react'
import { TableCell } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import YesNoSelect from '~/components/common/inputs/YesNoSelect'
import type {
  Invoice,
  InvoiceLineItem,
  InvoiceLineItemGroup,
  InvoiceUpdateFieldCallback,
} from '~/types'

import { formatMoneyRange, getTaxAmount } from '../../invoiceUtils'

const useStyles = makeStyles(
  () => ({
    taxSelectCell: {
      borderRight: 'none !important',
      width: 84,
    },
    amountCell: {
      minWidth: 85,
    },
  }),
  { name: 'TaxCellBody' },
)

export interface TaxCellBodyProps {
  className?: string
  group: InvoiceLineItemGroup
  hidePrice?: boolean
  invoice: Invoice
  isDeclined: boolean
  isGrouped: boolean
  isReadOnly: boolean
  item: InvoiceLineItem
  updateField: InvoiceUpdateFieldCallback
}

const TaxCellBody = ({
  className,
  invoice,
  item,
  isDeclined,
  isGrouped,
  isReadOnly,
  hidePrice = false,
  updateField,
  group,
}: TaxCellBodyProps) => {
  const classes = useStyles()

  const taxAmount = getTaxAmount(item, invoice)

  const showPrice = !isDeclined && !hidePrice

  return (
    <>
      <TableCell className={classNames(className, classes.taxSelectCell)}>
        {showPrice && !isGrouped && (
          <YesNoSelect
            disableUnderline
            disabled={isReadOnly || !item.priceTaxable}
            value={item.taxed}
            onChange={(event) => updateField(event, 'taxed', group, item, true)}
          />
        )}
      </TableCell>
      <TableCell
        align="right"
        className={classNames(className, classes.amountCell)}
      >
        {showPrice && formatMoneyRange(taxAmount)}
      </TableCell>
    </>
  )
}

export default TaxCellBody
